import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY } from 'rxjs';
import { ClientService } from 'src/app/services/client.service';
import { ModalService } from 'src/app/services/modal.service';
import { GenericModalType } from 'src/app/types/modals';
import { LoaderController } from 'src/app/utils/loader-controller';
import { hashFormValidator } from 'src/app/validators/hash.form-validator';

@Component({
  selector: 'app-subsidy-code-activation',
  templateUrl: './subsidy-code-activation.component.html',
  styleUrls: ['./subsidy-code-activation.component.scss'],
})
export class SubsidyCodeActivationComponent implements OnInit {
  public readonly codeControl = new FormControl<string>('', [
    Validators.required,
    hashFormValidator(),
  ]);
  public readonly loader = new LoaderController();

  constructor(
    public readonly modalService: ModalService,
    private readonly clientService: ClientService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit() {
    return;
  }

  onActivateClick(): void {
    this.loader.enqueue();
    this.codeControl.disable();
    const code = this.codeControl.value!;
    this.clientService
      .registerCompanyCode(code)
      .pipe(
        catchError((err) => {
          this.loader.dequeue();
          this.codeControl.enable();
          this.modalService
            .showGenericInfoPopup({
              header: this.translateService.instant(
                '@components.subsidyCodeActivation.request.error.header'
              ),
              message: this.translateService.instant(
                '@components.subsidyCodeActivation.request.error.message'
              ),
              type: GenericModalType.ERROR,
            })
            .subscribe();
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.modalService.dismiss(true);
        this.loader.dequeue();
      });
  }
}
